export default __webpack_public_path__ + "static/media/black-logo.86323618.png";